import { render } from "./submit-alternate.vue?vue&type=template&id=0ce93a96"
import script from "./submit-alternate.vue?vue&type=script&lang=js"
export * from "./submit-alternate.vue?vue&type=script&lang=js"

import "./submit-alternate.vue?vue&type=style&index=0&id=0ce93a96&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__